import moment from "moment";

export default class DateUtils {
    public static getElapsedTime(time: number): string {
        return moment(time).fromNow()
    }
}